import React,{useEffect,useState,useMemo} from 'react';
import TranslateIcon from '@mui/icons-material/Translate';
import api from '@src/api/axiosInstance';
import {needsSpanishTranslation} from '@src/helpers/Translation';
import * as Styled from './ChatMessage.styles';
import './IncomingTranslation.css';
export default function IncomingTranslation({id,text,outgoing=false}:{id:string;text:string;outgoing?:boolean}){
 const eligible=useMemo(()=>needsSpanishTranslation(text),[text]);
 const [open,setOpen]=useState(false),[result,setResult]=useState(''),[error,setError]=useState(''),[busy,setBusy]=useState(false);
 useEffect(()=>{setOpen(false);setResult('');setError('');setBusy(false);},[id,text]);
 useEffect(()=>{
  if(!open||result)return;
  let cancelled=false;setBusy(true);setError('');
  api.post('/translation/',{message_id:id,target:'es'},{timeout:45000}).then(r=>{if(!cancelled)setResult(r.data.suggestion);}).catch(e=>{if(!cancelled)setError(e.response?.data?.detail||'No se ha podido traducir.');}).finally(()=>{if(!cancelled)setBusy(false);});
  return()=>{cancelled=true;};
 },[id,text,open]);
 if(!eligible)return null;
 return <>
  <Styled.Actions $isRight={!outgoing} className={'cv-incoming-translation-action'+(outgoing?' is-outgoing':'')} style={{top:4,opacity:open?1:undefined}}>
   <Styled.Action as="button" type="button" style={{border:0,padding:0}} title={open?'Ocultar traducción':'Traducir al español'} aria-label={open?'Ocultar traducción':'Traducir al español'} aria-expanded={open} onClick={()=>setOpen(!open)}><TranslateIcon/></Styled.Action>
  </Styled.Actions>
  {open&&<section className="cv-incoming-translation" aria-label="Traducción al español" aria-live="polite">
   <div className="cv-incoming-translation__heading"><TranslateIcon/><span>Español</span><span className="cv-incoming-translation__automatic">Traducción automática</span></div>
   <div className={'cv-incoming-translation__text'+(busy?' is-loading':'')}>{busy?'Traduciendo…':error||result}</div>
  </section>}
 </>;
}
